/*
 *
 *  * Copyright(c) 2024 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { Pipe, PipeTransform } from '@angular/core';
import { UtilService } from '@app/util/util.service';
import { AppConfigService } from '@app/common/app-config.service';

@Pipe({
  name: 'translateNhi'
})
export class TranslateNhiPipe implements PipeTransform {
  constructor(private util: UtilService, private appConfig: AppConfigService) {}

  transform(resourceKey): string {
    return this.util.getLocalizedNHISpecificText(resourceKey, this.appConfig.getNHIType());
  }
}
